import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Filtros from "@Composicion/Filtros/Filtros";

import "./ExcepcionSubOpcionRolMenu.css";
function ExcepcionSubOpcionRolMenu() {
  const origenComponente = "ExcepcionSubOpcionRolMenu";
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},
  });
  return (
    <div className={"ExcepcionSubOpcionRolMenuCSS-contenedor"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {modal_mostrar:false});
          }}
        ></ModalInformacion>
      )}
      <div className="titulo-componente">{"Excepcion de Sub Opcion Rol Menú"}</div>
      <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      />
      <_tabla_.Tabla
        origen={origenComponente}
        cabecera={v_u.da_headgrid}
        registros={v_u.da_grid}
        filtros={v_u.do_filtrosActualizados}
        modoVista={"modo2"}
        permiteVerCategoriaCompleta={false}
        permiteMultiseleccion={v_u.d_multiselecion}
        permiteOpciones={true}
        opcionesPorDefecto={0b00_000_000}
        camposCodigosSeleccion={["codigo"]}
        campoCodigoCategoria={"categoria"}
        campoCodigoRegistrosPorCategoria={"registros"}
        campoOpcionesTablaInterna={"opcionesTablaInterna"}
        // datosComplementarios={{
        //   codigoPrecioVenta: v_u.d_codigoDistribuidor,
        //   ...v_u.do_datosTabla,
        // }}
        // reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
        // mapaDeComponentes={{
        //   formulario: _form_.Formulario,
        //   0b1: _form_.Formulario,
        //   0b010_000_000: _form_.Formulario,
        // }}
        fObtenerSeleccionados={(seleccionados) => {
          _f_.asignar(ev_u, { do_seleccionados: seleccionados });
        }}
        fNotificarActualizacionDeTabla={(actualizar) => {
          if (actualizar) {
            _f_.asignar(ev_u, {
              d_actualizarTabla: !v_u.d_actualizarTabla,
            });
          }
        }}
        fObtenerDatosParcialesActualizados={(datos) => {
          console.log(datos);
          _f_.asignar(ev_u, { d_totalSolicitado: datos?.total_pedido });
        }}
      />
    </div>
  );
}
export default ExcepcionSubOpcionRolMenu;
